const AI = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E6':
            return `<category
                        name="%{BKY_CATEGORY_AI}"
                        id="ai"
                        colour="#DA70D6"
                        secondaryColour="#DA50D6"
                        showLabelButton="true">
                    <block type="sensor_setAICamData"/>
                    <block type="sensor_getAICamData"/>
                    ${categorySeparator}
                    <block type="sensor_setWaitForAICamData"/>
                    <block type="sensor_getAICamDataColorDetect"/>
                    <block type="sensor_getAICamDataQR"/>
                    <block type="sensor_getAICamDataBall"/>
                    <block type="sensor_getAICamDataRoad"/>
                    <block type="sensor_getAICamDataFaceDetect"/>
                    <block type="sensor_getAICamDataImage"/>
                    <block type="sensor_getAICamDataImageStudy"/>
                    <block type="sensor_getAICamDataGesture"/>
                    <block type="sensor_getAICamDataApriltag"/>
                    <block type="sensor_getAICamDataColorLearning"/>
                    <block type="sensor_getAICamDataFaceLearning"/>
                    ${blockSeparator}
                    <block type="sensor_getAICamVoice"/>
                    ${blockSeparator}
                    </category>
                    `;

        case 'E7':
            return `<category
                        name="%{BKY_CATEGORY_E7_AI}"
                        id="ai"
                        colour="#DA70D6"
                        secondaryColour="#DA50D6"
                        showLabelButton="true">
                        <block type="AI_startCamera"/>
                        <block type="AI_setFaceRegister">
                            <value name="NAME">
                                <shadow type="textvalue">
                                    <field name="TEXT">name</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getZxing"/>
                        <block type="AI_setAiResult"/>
                        <block type="AI_getBlackLineData"/>
                        <block type="AI_GetRoadAngle"/>
                        <block type="AI_getAiData"/>
                        <block type="E7_setTTS">
                            <value name="VALUE">
                                <shadow type="textvalue">
                                   <field name="TEXT">你好</field>
                                </shadow>
                            </value>
                        </block>
                        ${false ? `
                        <block type="AI_isFaceResult">
                            <value name="DATA">
                                <shadow type="text">
                                    <field name="TEXT">0</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getFaceResult"/>
                        <block type="AI_getPost"/>
                        <block type="AI_setStartMF"/>
                        <block type="AI_getMFColor">
                            <value name="VALUE">
                                <shadow type="math_number">
                                    <field name="NUM">1</field>
                                </shadow>
                            </value>
                        </block>`: null}
                        
                        <block type="AI_getWeather">
                            <value name="city">
                                <shadow type="AI_city_menu">
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getPoseData"/>
                        <block type="AI_SetCameraShow"/>
                        <block type="AI_getSimplePoseList"/>

                        ${false ? `<block type="AI_getResult"/>
                        <block type="AI_isFingerResult"/>
                        <block type="AI_isTraficResult"/>
                        <block type="AI_isSimplePoseBy"/>
                        <block type="AI_isAiData">
                            
                            <value name="RESULT">
                                <shadow type="math_number">
                                    <field name="NUM">1</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getLeft"/>
                        <block type="AI_getRight"/>
                        <block type="AI_isShipForward"/>
                        <block type="AI_isShipBack"/>
                        <block type="AI_getShipSpeed"/>
                        <block type="AI_getForecastTrue">
                            <value name="ARG1">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG2">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG3">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG4">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getForecastType">
                            
                            <value name="ARG1">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG2">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG3">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                            <value name="ARG4">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getSimplePoseList"/>
                        <block type="AI_getMfByBt"/>
                        <block type="AI_isMfConnect"/>
                        <block type="AI_isHandShock"/>
                        <block type="AI_isMfFinish"/>
                        <block type="AI_runNext"/>
                        <block type="AI_searchMf"/>
                        <block type="AI_startMFColor"/>
                        <block type="AI_getRunSpeed"/>` : null}
                        
                        
                    </category>
                    <category
                        name="%{BKY_CATEGORY_CLOUD}"
                        id="AIyun"
                        colour="#DA70D6"
                        secondaryColour="#DA50D6"
                        showLabelButton="true">
                        <block type="AI_startBDApi"/>
                        <block type="AI_setTextRecognize"/>
                        <block type="AI_getVoiceData"/>
                        <block type="AI_startBDVoiceRecognize">
                            <value name="TIME">
                                <shadow type="math_number">
                                    <field name="NUM">3</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="AI_getTextRecognizeResult"/>
                    </category>
                    `;

        case 'STORM_OS':
            return `
                <category
                    name="图像"
                    id="STORE_OS_IMG"
                    colour="#4aaf8d"
                    secondaryColour="#4aaf8d">
                    <block type="STORM_OS_take_photo"></block>
                    <block type="STORM_OS_imread_sensestorm">
                        <value name="PATH">
                            <shadow type="textvalue">
                                <field name="TEXT">image_path</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_imshow_sensestorm"></block>
                    <block type="STORM_OS_imwrite_sensestorm">
                        <value name="PATH">
                            <shadow type="textvalue">
                                <field name="TEXT">output.jpg</field>
                            </shadow>
                        </value>
                    </block>
                ${blockSeparator}
                </category>
                <category
                    name="输出"
                    id="STORE_OS_PRINT"
                    colour="#2c9958"
                    secondaryColour="#2c9958">
                    <block type="STORM_OS_PRINT">
                        <value name="TEXT">
                            <shadow type="textvalue">
                                <field name="TEXT">label</field>
                            </shadow>
                        </value>
                    </block>
                ${blockSeparator}
                </category>
                <category
                    name="AI-人脸识别"
                    id="STORE_OS_AI_FACE"
                    colour="#1a408f"
                    secondaryColour="#1a408f">
                    <block type="STORM_OS_get_face_attributes"></block>
                    <block type="STORM_OS_is_face_smiled"></block>
                    <block type="STORM_OS_get_face_attribute_two"></block>
                    <block type="STORM_OS_is_face_existed"></block>
                    <block type="STORM_OS_detect_face"></block>
                    <block type="STORM_OS_extract_face_feature"></block>
                    <block type="STORM_OS_calculate_feature_similarity"></block>
                    <block type="STORM_OS_get_face_pose"></block>
                ${blockSeparator}
                </category>
                <category
                    name="AI-人体识别"
                    id="STORE_OS_AI_BODY"
                    colour="#2b772e"
                    secondaryColour="#2b772e">
                    
                    <block type="STORM_OS_is_hand_existed"></block>
                    <block type="STORM_OS_detect_hand"></block>
                    <block type="STORM_OS_is_gesture_existed"></block>
                    <block type="STORM_OS_detect_gesture"></block>
                    <block type="STORM_OS_detect_hand_points"></block>
                    <block type="STORM_OS_is_body_existed"></block>
                    <block type="STORM_OS_detect_body"></block>
                    <block type="STORM_OS_detect_body_key_points"></block>
                ${blockSeparator}
                </category>
                <category
                    name="AI-图像检测"
                    id="STORE_OS_AI_IMG"
                    colour="#827315"
                    secondaryColour="#827315">
                    <block type="STORM_OS_is_ball_existed"></block>
                    <block type="STORM_OS_detect_ball"></block>
                    <block type="STORM_OS_classify_image"></block>
                    <block type="STORM_OS_detect_lane_line"></block>
                    <block type="STORM_OS_get_pid_speed"></block>
                    <block type="STORM_OS_detect_plant"></block>
                    <block type="STORM_OS_detect_mineral"></block>
                    <block type="STORM_OS_get_result_label"></block>
                    <block type="STORM_OS_get_result_coordinate"></block>
                ${blockSeparator}
                </category>
                <category
                    name="AI-机器学习"
                    id="STORE_OS_AI_MACHINA"
                    colour="#991117"
                    secondaryColour="#991117">
                    <block type="STORM_OS_extract_imageNet"></block>
                    <block type="STORM_OS_train_classifier">
                    
                        <value name="NAME">
                            <shadow type="text">
                                <field name="TEXT">img_path</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_save_model">
                    
                        
                        <value name="RENAME">
                            <shadow type="text">
                                <field name="TEXT">model</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_load_model">
                    
                        <value name="NAME">
                            <shadow type="text">
                                <field name="TEXT">model</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_predict"></block>
                ${blockSeparator}
                </category>
                <category
                    name="AI-智能语音"
                    id="STORE_OS_AI_AUDIO"
                    colour="#620976"
                    secondaryColour="#620976">
                    <block type="STORM_OS_speak">
                        
                        <value name="TEXT">
                            <shadow type="text">
                                <field name="TEXT">text</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_classify_audio">
                        
                        <value name="FILENAME">
                            <shadow type="text">
                                <field name="TEXT">output.wav</field>
                            </shadow>
                        </value>
                    </block>
                ${blockSeparator}
                </category>
                `;

        default:
            return `<category
                            name="%{BKY_CATEGORY_AI}"
                            id="ai"
                            colour="#DA70D6"
                            secondaryColour="#DA50D6">
                        </category>
                        `;
    }
};

export default AI;
